import type { ForeignEntityId } from "../handles/foreignEntityId";

export interface PlanarTopologyDatumBounds {
  readonly startHorizontalDatumId?: ForeignEntityId<"DATUM">;
  readonly endHorizontalDatumId?: ForeignEntityId<"DATUM">;
  readonly startVerticalDatumId?: ForeignEntityId<"DATUM">;
  readonly endVerticalDatumId?: ForeignEntityId<"DATUM">;
}

export function planarTopologyDatumBoundsHasDatums(bounds: PlanarTopologyDatumBounds): boolean {
  return (
    bounds.startHorizontalDatumId !== undefined ||
    bounds.endHorizontalDatumId !== undefined ||
    bounds.startVerticalDatumId !== undefined ||
    bounds.endVerticalDatumId !== undefined
  );
}
